import { render, staticRenderFns } from "./record.vue?vue&type=template&id=40aac9e8&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style1 from "./record.vue?vue&type=style&index=1&id=40aac9e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aac9e8",
  null
  
)

export default component.exports